<template>
  <el-dialog
    :title="post.post_id?'编辑职务':'添加职务'"
    :visible.sync="show"
    width="30%"
    @close="onClose"
    :close-on-click-modal="false"
  >
    <div class="column-view">
      <el-form label-position="right" label-width="100px">
        <el-form-item label="职务名称" required>
          <el-input placeholder="请输入职务名称名称" v-model="post.post_name"></el-input>
        </el-form-item>
        <el-form-item label="角色属性" required>
          <select-job-grade style="width: 100%" @onSelectJobChanged="onSelectJobChanged" :job="post.post_attribute"></select-job-grade>
        </el-form-item>

        <el-form-item label="职务说明">
          <el-input type="textarea" v-model="post.post_note"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="()=>{this.show=false}">取 消</el-button>
      <el-button type="primary" @click="onSaveClick()" >保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import selectJobGrade from "@/views/setting/jobGradeManagement/components/selectJobGrade";
export default {
  name: "createEditPartmentDialog",
  components: {selectJobGrade},
  data() {
    return {
      show: false,

      post:{
        post_name:'',
        post_id:'',
        post_note:'',
        post_attribute:'',
      }
    }
  },
  methods: {
    onSelectJobChanged(e){
      this.post.post_attribute=e;
    },

    onSaveClick(){
      if(!this.post.post_name){
        return this.$commonUtils.showMessage('请输入职务名称','error')
      }
      if(!this.post.post_attribute){
        return this.$commonUtils.showMessage('请选择职务属性','error')
      }
      let request_data={
        post_name:this.post.post_name,
        post_attribute:this.post.post_attribute,
        post_note:this.post.post_note
      }
      if(this.post.post_id){
        request_data['id']=this.post.post_id
      }

      this.$prompt('确认保存当前职务信息', '保存职务信息', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '保存中...'
            this.http.api(this.post.post_id?'editPost':'addPost', request_data).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '保存'
                done()
                this.show=false;
                this.$commonUtils.showMessage('操作成功', 'success')
                this.$emit('onRefreshData')
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '保存'
              }
            }).catch(() => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '保存'
            })
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })


    },


    onClose() {
      this.post={
        post_name:'',
        post_id:'',
        post_note:'',
        post_attribute:'',
      }

    },

    setData(data) {
      this.show = true;
      this.post=data;
    },

    showDialog() {
      this.show = true;
    },
  }
}
</script>

<style scoped>

</style>
